export const colorPalette = {
  black: {
    light1: 'rgba(0,0,0,0.1)',
    light2: 'rgba(0, 0, 0, 0.2)',
    light3: 'rgba(0,0,0,0.3)',
    light36: 'rgba(0, 0, 0, 0.36)',
    light5: 'rgba(0,0,0,0.5)',
    light8: 'rgba(0,0,0, 0.8)',
    base: '#000000',
    base1: '#2f281e',
  },
  grey: {
    light1: 'rgba(216, 216, 216)',
    lightd0: '#d0d0d0',
    lightc5: '#c5c5c5',
    lightc3: '#c3c3c3',
    lightc2: '#c2c2c2',
    lightdd: '#dddddd',
    lightd8: '#d8d8d8',
    lightd7: '#d7d7d7',
    lightba: '#bababa',
    lighte5: '#e5e5e5',
    lightef: '#efefef',
    lighte7: '#e7e7e7',
    lightf2: '#f2f2f2', 
    lightf6: '#f6f6f6',
    lightf9: '#f9f9f9',
    light07: 'rgba(155, 155, 155, 0.7)',
    light46: 'rgba(243, 243, 243, 0.46)',
    light50: 'rgba(173, 171, 171, 0.5)',
    light9b: '#9b9b9b',
    dark3: '#333333',
    dark3e: '#3e3e3e',
    dark74: '#747474',
    base: '#4a4a4a',
    base1: '#979797',
    dark24: '#242424',


    //goibibo colors
    grey15: '#dcddde',
    grey50: '#898b91',
    grey75: '#4f525a',
    lightGrey: '#c9d4e1',
    lineGrey: '#eff3f8',
    bgGrey: '#e9eff5',
  },
  blue: {
    light: '#abd5ff',
    lighted: '#edf7ff',
    lightf2: '#f2f9ff',
    lightea: '#eaf5ff', 
    lightef: '#eef4fd',
    lightd1: '#d1e2f5',
    light04: 'rgba(19, 74, 129, 0.4)',
    light06: 'rgba(0, 145, 255, 0.06)',
    light36: 'rgba(0, 145, 255, 0.36)',
    light01: 'rgba(0, 140, 255, 0.1)',
    dark: '#134a81',
    base: '#008cff',
    brand: '#0a223d',
    dark06: '#061e39',
    dark3b: '#3b385e',
    blueBg: '#f4faff',

    //gibibo colors
    bgBlue: '#eef4fd',
    deepBlue: '#1951b5',
    lightBlue: '#d1e5ff',
    bgBlueLight: '#accff9',
    bgBlueLightHome: '#6da4ea',
    bgSegmentDark: '#1149f3',
    bgSegmentLight: '#00c3ff',
    blueBorder: '#e5edf6',
  },
  red: {
    lightff: '#ffbdc0',
    light1: '#ffd3d4',
    base: '#eb2026',
    base1: '#e02020',
    bgRedLight: '#fff6f6',
    bgRedDark: '#ffe8e9',
    darkd0: '#d0201d',



    //goibibo colors
    // base: '#ff3a5c',
    lightRed: '#ffebee',
    // bgRed: '#feebf0',
    pinkRed: '#ff8a9e',
    bgLightRed: '#ffe7e5',
    ratingRed: '#9b041e',
  },
  green: {
    light2f: '#2fc8af',
    base: '#249995',
    light1: '#26b5a9',
    lgihtc1: '#c1f1dd',
    dark: '#1a7971',
    bgGreen: '#d7fae2',
    bgLightd6: '#d6f6f3',
    dark1: '#37474f',


    //goibibo colors
    // base: '#2bac36',
    lightGreen: '#e9f6ea',
    // bgGreen: '#7ccf51',
    bgGreenDark: '#18a160',
    darkBushGreen: '#11998e',
    cGreen: '#dafac9',
    cGreenDark: '#63c033',
    ratingGreen: '#5fa735',
    bgDarkGreen: '#039556',
    darkGreen: '#005d2f',
    cGreenNew: '#7cd051',
    taGreen: '#00b087',
  },
  yellow: {
    bgLightff: '#ffedd1',
    bgYellow: '#fff0d1',
    lightfe: '#fefcf0',
    bgLight: '#fff8ec',
    bgLgihtfe: '#fefcf0',
    darkcf: '#cf8100',
    dark8b: '#8b572a',


    //goibibo colors
    base: '#fdba00',
    lightYellow: '#fef8e5',
    // bgYellow: '#fff5da',
    darkerYellow: '#fdaf15',
    lightCream: '#fdf3d9',
    cYellow: '#f39c12',
    borderYellow: '#fee6a0',
    ratingYellow: '#f59d00',
    darkGold:'#aa9a55',
    lightGold:'#d2bd60',
  },
  white: {
    base: '#ffffff',
    bgWhite: '#fafcfe',
    bgWhite1: '#f7f7f7',
    light15: 'rgba(255,255,255,0.15)'
  },
  brown: {
    darkBrown: '#614919',
    warmBrown: '#854700f7',
  },
  purple: {
    base: '#861388',
    lightPurple: '#f2e7f3',
  },
  cyan: {
    base: '#1aabb8',
  },
  amber: {
    base: '#8e5a14',
  },
  goBrand: {
    blue: '#2276e3',
    orange: '#ff6d38',
    goStays: '#ff7d22',
  },
  orange: {
    bgOrange: '#fcbe5b',
    lightOrange: '#ffe3b7',
    base: '#eda93c',
    ratingOrange: '#ed6112',
  },
  pink: {
    base: '#fff0eb',
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)',
  },


};


export function buildColors() {
  return colorPalette;
}
